import '@styles/help.scss'

import './utils/generalModules'

import './modules/car-histoy-toggles'
import './modules/faq-tabs'
import './modules/chat'